import { useRef, useState, useMemo } from 'react';
import styles from './FJMobileSimplePreviewModal.module.less';
import classNames from 'classnames';
import FJImage from '../../../common/components/FJImage/FJImage';
import CloseIcon from '../../../assets/svg/mobile-close.svg?react';
import PropTypes from 'prop-types';

const FJMobileSimplePreviewModal = props => {
    const { data = {}, visible, onClose } = props;
    const containerRef = useRef(null);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    // #region 初始化部分

    const imgBoxRect = useMemo(() => {
        let obj = {};
        if (containerRef.current) {
            const ratio = data.width / data.height;
            const containerW = containerRef.current.offsetWidth;

            const maxH = containerRef.current.offsetHeight;
            let w = 0;
            let h = 0;
            if (ratio >= 1) {
                w = containerW;
                h = w / ratio;
            } else {
                w = containerW - 64;
                h = w / ratio;
            }
            if (h > maxH) {
                h = maxH;
                w = h * ratio;
            }
            if (w > 0 && h > 0) {
                obj = { height: h, width: w };
            }
        }
        return obj;
    }, [data]);

    // #endregion

    //#region 触摸事件
    // 处理触摸开始
    const _handleTouchStart = e => {
        setTouchStart({ x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY });
        setIsDragging(true);
    };

    // 处理触摸移动
    const _handleTouchMove = e => {
        if (!isDragging) return;
        setTouchEnd({ x: e.targetTouches[0].clientX, y: e.targetTouches[0].clientY });
    };

    // 处理触摸结束
    const _handleTouchEnd = () => {
        setIsDragging(false);

        if (!touchStart || !touchEnd) return;

        const verticalDistance = touchStart.y - touchEnd.y;
        const minVerticalSwipeDistance = -70; // 向下垂直最小滑动距离
        if (verticalDistance < minVerticalSwipeDistance) {
            onClose();
        }
        setTouchStart(null);
        setTouchEnd(null);
    };
    //#endregion

    return (
        <div
            className={classNames(styles.container, visible ? styles.fade_in : styles.fade_out)}
            ref={containerRef}
            onTouchStart={_handleTouchStart}
            onTouchMove={_handleTouchMove}
            onTouchEnd={_handleTouchEnd}
        >
            <div className={styles.close} onClick={onClose}>
                <CloseIcon />
            </div>
            <FJImage
                imgSrc={data.src}
                boxClassName={classNames(styles.img)}
                isShowLoading={true}
                style={{ width: imgBoxRect?.width, height: imgBoxRect?.height }}
            />
        </div>
    );
};
FJMobileSimplePreviewModal.propTypes = {
    visible: PropTypes.bool,
    data: PropTypes.object,
    onClose: PropTypes.func,
};
export default FJMobileSimplePreviewModal;
